import { render, staticRenderFns } from "./MainCapital.vue?vue&type=template&id=37ce65e4&scoped=true&"
import script from "./MainCapital.vue?vue&type=script&lang=js&"
export * from "./MainCapital.vue?vue&type=script&lang=js&"
import style0 from "./MainCapital.vue?vue&type=style&index=0&id=37ce65e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce65e4",
  null
  
)

export default component.exports